import React from "react";
import { Download, Loader2 } from "lucide-react";

import { Button } from "@musa.tech/design-system";
import { usePermissions } from "@/hooks/useUnifiedAuth";
import { useEvidenceDownload } from "@/hooks/useEvidenceDownload";
import type { EvidenceSide } from "@/utils/evidenceMediaKind";

interface EvidenceDownloadButtonProps {
  url: string;
  collectId: string;
  side: EvidenceSide;
  /** "Antes da coleta" / "Depois da coleta" — compõe o nome acessível. */
  label: string;
}

/** Baixar a evidência da coleta — só usuário Musa. */
export const EvidenceDownloadButton: React.FC<EvidenceDownloadButtonProps> = ({
  url,
  collectId,
  side,
  label,
}) => {
  const { isInternal } = usePermissions();
  const { mutate, isPending } = useEvidenceDownload();

  if (!isInternal) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      disabled={isPending}
      onClick={() => mutate({ url, collectId, side })}
      aria-label={`Baixar evidência ${label.toLowerCase()}`}
    >
      {isPending ? (
        <Loader2 className="mr-1 h-4 w-4 animate-spin" />
      ) : (
        <Download className="mr-1 h-4 w-4" />
      )}
      Baixar
    </Button>
  );
};
